/** @format */

export * from './strikethrough-price.module';
